import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import reduxThunk from 'redux-thunk';

import web3Reducer from './reducers/web3Reducer';
import auctionItemsReducer from './reducers/auctionItemsReducer';
import saleItemsReducer from './reducers/saleItemsReducer';
import myItemsReducer from './reducers/myItemsReducer';
import itemReducer from './reducers/itemReducer';
import userAccountReducer from './reducers/userAccountReducer';
import activityReducer from './reducers/activityReducer';
import firebaseReducer from './reducers/firebaseReducer';

export default function configureStore() {
  const reducers = combineReducers({
    web3Reducer,
    auctionItemsReducer,
    saleItemsReducer,
    myItemsReducer,
    itemReducer,
    userAccountReducer,
    activityReducer,
    firebaseReducer
  });

  const rootReducer = (state, action) => {
    if (action.type === 'RESET_STORE') {
      state = undefined;
    }

    return reducers(state, action);
  }

  // https://github.com/zalmoxisus/redux-devtools-extension#usage
  const composeEnhancers =
  process.env.NODE_ENV !== 'production' &&
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    }) : compose

  const enhancer = composeEnhancers(
    applyMiddleware(reduxThunk)
    // other store enhancers if any
  );

  const store = createStore(rootReducer, enhancer);

  return store;
}



// WEBPACK FOOTER //
// ./src/redux/configureStore.js